/**
 * 품의(approval) 전용 코멘트 엔드포인트 — portal `/api/v1/comment/*` 와 **별개**.
 *
 *   GET    /api/v2/approval/{documentId}/comments        스레드 전체 조회 (페이징 없음)
 *   POST   /api/v2/approval/{documentId}/comments        코멘트 작성 — 201 응답이 갱신된 스레드 전체
 *   PUT    /api/v2/approval/{documentId}/comments/{commentId}            코멘트 수정 ({content, attachments, mentions})
 *   DELETE /api/v2/approval/{documentId}/comments/{commentId}            soft 삭제
 *   PUT    /api/v2/approval/{documentId}/comments/{commentId}/recommend  좋아요 ({recommend: boolean})
 *
 * 서버가 문서번호로 유효 스레드를 찾고 없으면 새로 여니 코멘트 그룹 조회/생성 호출은 없음.
 * `commentGroupId` 는 재상신 때 값이 바뀌므로 보관 금지.
 */

const APPROVAL_V2_BASE = '/api/v2/approval';

export const approvalCommentApi = {
  /** @GET 스레드 조회 / @POST 코멘트 작성 — body {content, attachments, mentions} */
  COMMENTS: (documentId: string) =>
    `${APPROVAL_V2_BASE}/${documentId}/comments`,
  /** @PUT 코멘트 수정 — body {content, attachments, mentions} / @DELETE 코멘트 soft 삭제 */
  DETAIL: (documentId: string, commentId: string) =>
    `${APPROVAL_V2_BASE}/${documentId}/comments/${commentId}`,
  /** @PUT 좋아요 — body {recommend: boolean} */
  RECOMMEND: (documentId: string, commentId: string) =>
    `${APPROVAL_V2_BASE}/${documentId}/comments/${commentId}/recommend`,
};
